const getters = {
  students: (state) => state.students,
  student: (state) => state.student,
  processing: (state) => state.processing,
  processingStudent: (state) => state.processingStudent,
};

export default getters;
